import axios from 'axios';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { Platform } from 'react-native';
import { API_BASE_URL } from '../utils/constants';

const API_URL = API_BASE_URL;

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: Platform.OS === 'web',
    timeout: 30000,
    timeoutErrorMessage: 'Request timed out - please check your internet connection',
    maxContentLength: Infinity,
    maxBodyLength: Infinity
});

api.interceptors.request.use((config) => {
    console.log(`${config.method?.toUpperCase()} ${config.baseURL}${config.url}`);
    return config;
});

api.interceptors.request.use(async (config) => {
    try {
        const token = await AsyncStorage.getItem('token');
        if (token) {
            config.headers = {
                ...config.headers,
                'Authorization': `Bearer ${token}`
            };
            if (config.data instanceof FormData) {
                config.headers['Content-Type'] = 'multipart/form-data';
            }
        }
        return config;
    } catch (error) {
        console.error('Error adding auth token to request:', error);
        return config;
    }
});

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (error.code === 'ECONNABORTED') {
            throw new Error('Request timed out. Please check your internet connection.');
        }

        if (!error.response) {
            throw new Error('Network error. Please check your internet connection.');
        }

        if (error.response.status === 401) {
            await AsyncStorage.multiRemove(['token', 'user']);
            throw new Error('Authentication failed. Please log in again.');
        }

        // Do not flatten the error to a string here, as callers (like api/auth.js) 
        // need to access error.response.data for detailed error messages.
        return Promise.reject(error);
    }
);

export default api;
